import { useIsMobile } from '@/hooks';
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from '@e2n/ui';
import { useTranslation } from 'react-i18next';

// oxlint-disable-next-line max-lines-per-function
export function ConfirmDialog({
  isOpen,
  setIsOpen,
  isSubmitting,
}: {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  isSubmitting: boolean;
}) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Drawer open={isOpen} onOpenChange={setIsOpen}>
        <DrawerContent className="flex flex-col items-center gap-5 p-4">
          <DrawerHeader className="text-left">
            <DrawerTitle>
              {t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.planExistiert.dialogTitle',
              )}
            </DrawerTitle>
          </DrawerHeader>
          <div className="text-sm text-neutrals-900">
            {t(
              'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.planExistiert.dialogSubTitle',
            )}
          </div>
          <div className="w-full flex flex-col gap-4">
            <Button
              className="w-full"
              variant="outline"
              onClick={() => setIsOpen(false)}>
              {t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.planExistiert.cancel',
              )}
            </Button>
            <Button
              form="createRotationsplanForm"
              className="w-full"
              disabled={isSubmitting}>
              {t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.planExistiert.confirm',
              )}
            </Button>
          </div>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t(
              'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.planExistiert.dialogTitle',
            )}
          </DialogTitle>
        </DialogHeader>
        <div className="text-sm text-neutrals-900">
          {t(
            'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.planExistiert.dialogSubTitle',
          )}
        </div>
        <div className="flex justify-end gap-4">
          <Button variant="outline" onClick={() => setIsOpen(false)}>
            {t(
              'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.planExistiert.cancel',
            )}
          </Button>
          <Button form="createRotationsplanForm" disabled={isSubmitting}>
            {t(
              'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.planExistiert.confirm',
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
